import React from 'react'
import {Loading, Pagination, Text} from '@therms/atalaya'
import {
  NoResults,
  RPCDocs,
  RPCs,
  useLocationContext,
  usePaginationState,
  useRPC,
  useStateDebounced,
} from '@therms/react-modules'
import {LocationCard} from '@src/modules/Locations/router/screens/Index/components/LocationCard.tsx'
import {generatePath, useHistory} from 'react-router-dom'
import {LOCATIONS_ROUTES} from '@src/modules/Locations/constants.ts'
import {MdBusiness} from 'react-icons/md'

function SubLocationsList() {
  const {locationId} = useLocationContext(true)
  const {recordsPerPage, setRecordsPerPage, setSkippedRecords, skippedRecords} =
    usePaginationState('subloclist', [])

  const history = useHistory()
  const [searchTextValue, searchText, setSearchText] = useStateDebounced('')

  const {data, isCalling} = useRPC<
    RPCDocs.Locations.GetLocationsList.v1.Args,
    RPCDocs.Locations.GetLocationsList.v1.Data
  >(RPCs.Locations.GetLocationsList.v1, {
    active: true,
    pagination: {
      limit: recordsPerPage,
      skip: skippedRecords,
    },
    parentLocationId: locationId,
    searchText,
  })

  return (
    <div className="relative">
      {isCalling && <Loading overlay />}

      {(searchText ||
        (!!data?.total &&
          (data?.total > 25 || data?.total > recordsPerPage))) && (
        <div className="inline-flex w-full justify-between">
          <div className="gap-x-xs inline-flex items-center">
            <Text
              placeholder="Search..."
              onChangeValue={setSearchText}
              value={searchTextValue}
              search
            />
          </div>
        </div>
      )}

      {data?.locations?.length ? (
        <div className="flex flex-col">
          {data?.locations.map((location) => (
            <div className="pt-xs" key={location.id}>
              <LocationCard
                active={location.active}
                address={location.address}
                appliedServicePeriods={location.servicePeriods?.applied ?? 0}
                name={location.name}
                onClick={() =>
                  history.push(
                    generatePath(LOCATIONS_ROUTES.VIEW_LOCATION, {
                      locationId: location.id,
                    }),
                  )
                }
                primaryImageUrl={location.primaryImageUrl}
              />
            </div>
          ))}

          <div className="my-base">
            <Pagination
              onPageClick={setSkippedRecords}
              onSetRecordsPerPage={setRecordsPerPage}
              recordsPerPage={recordsPerPage}
              showDescription
              skippedRecords={skippedRecords}
              totalRecords={data?.total ?? 0}
            />
          </div>
        </div>
      ) : (
        <NoResults iconName={MdBusiness} text="No Sub-Locations" />
      )}
    </div>
  )
}

export {SubLocationsList}
